<template>
  <div>
    <t-label><a href="#" @click.prevent="uploadBox">
      <font-awesome-icon size="lg" class="text-gray-dark" icon="paperclip" /><span class="sr-only">Attach file</span>
    </a></t-label>



    <div class="drop-overlay pin absolute z-100 rounded items-center justify-center" :class="{
                                                                                    flex: isDropping,
                                                                                    hidden: !isDropping
                                                                                    }"

      @drop.prevent="drop($event)"
      @dragover.prevent
      @dragenter.prevent
      @dragleave.prevent="dragLeave($event)"
    >
      Drop your files here.
    </div>

    <div class="loading-overlay pin absolute z-100 rounded items-center justify-center" :class="{
                                                                                    flex: isLoading,
                                                                                    hidden: !isLoading
                                                                                    }"

    >
      Uploading...
    </div>
    <input type="file" ref="fileElem" accept="*" style="display:none" @change.prevent="handleUploadForm" />
  </div>


</template>

<script>
 import eventBus from '@/eventBus'

 import api from '@/api'

 export default {
   props: {
     isActive: {
       type: Boolean,
       default: false
     }
   },

   data () {
     return {
       isDropping: this.isActive,
       isLoading: false
     }

   },

   methods: {
     uploadBox () {
       this.$refs.fileElem.click();
     },

     dragEnter () {
       this.isDropping = true
     },

     dragLeave () {
       this.isDropping = false
       this.$emit('donedrop')
     },

     async drop (ev) {
       this.$emit('donedrop')
       this.isDropping = false
       // Prevent default behavior (Prevent file from being opened)
       const files = []

       if (ev.dataTransfer.items) {
         // Use DataTransferItemList interface to access the file(s)
         for (var i = 0; i < ev.dataTransfer.items.length; i++) {
           // If dropped items aren't files, reject them
           if (ev.dataTransfer.items[i].kind === 'file') {
             files.push(ev.dataTransfer.items[i].getAsFile());
           }
         }
       } else {
         // Use DataTransfer interface to access the file(s)
         for (var i = 0; i < ev.dataTransfer.files.length; i++) {
           //console.log('... file[' + i + '].name = ' + ev.dataTransfer.files[i].name);
         }
       }


       this.isLoading = true

       await this.handleFiles(files)

       this.isLoading = false
     },

     async handleUploadForm (ev) {
       this.isLoading = true
       await this.handleFiles(event.target.files)
       this.isLoading = false
     },

     async handleFiles (files) {
       const vm = this;
       return new Promise(async (resolve, reject) => {
         const promises = []


         for (let i = 0; i < files.length; i++) {
           const file = files[i];

           // if (!file.type.startsWith('image/')){ continue }

           const reader = new FileReader();

           promises.push(new Promise((resolve, reject) => {
             reader.addEventListener("load", async function () {
               // convert image file to base64 string

               const {res, err} = await api.uploadFile(file)

               if (err) {
                 // TODO: handle error
                 vm.$emit('error', err.response.data)
                 resolve({error: err.response.data})
               }

               let el = `://("tap://${res.id}.${res.ext}" "${res.original_name}")`

               if (/^image/.test(res.mime)) {
                 let tl;
                 if (res.ext === 'gif') {
                   tl = `${res.id}.gif`
                 } else {
                   tl = `${res.thumb_600}`
                 }

                 el += `
("tap://${tl}" "")`
               }

               vm.$emit('uploaded', el)

               resolve(el)
             }, false)
           }))

           if (file) {
             reader.readAsDataURL(file);
           }
         }

         resolve(await Promise.all(promises))
       })

     },
   },
   watch: {
     isActive (to) {
       this.isDropping = to
     }
   }
 }
</script>


<style scoped>
 .drop-overlay, .loading-overlay {
   background: rgba(255, 255, 255, .8);
   font-weight: bold;
 }
</style>
